export const editorUrl = process.env.VUE_APP_PUBLIC_PATH // 编辑器接口地址
// export const uploadApi = process.env.VUE_APP_BASE_API_URL; // 上传接口
